module.exports = __webpack_public_path__ + "img/icon-send-money-fill.5c80c305.svg";